import React, { Component } from 'react';
import MultiplosExamesPage from './multiplosExames.page';
import WebapiCommon from '../util/webapi.common';

class MultiplosExamesContainer extends Component {
  constructor() {
    super();
    this.state = {
      multiplosExames: [],
    };
  }

  componentDidMount() {
    WebapiCommon.getListagemMultiplosExames(this.props.laudo).then((exames) => {
      this.setState({ multiplosExames: exames });
    });
  }

  render() {
    return (
      <MultiplosExamesPage
        alturaEditor={this.getAltura.bind(this)}
        multiplosExames={this.state.multiplosExames}
        altura={this.props.altura}
      />
    );
  }

  getAltura = () => {
    return (
      document.getElementById('container-editor') &&
      document.getElementById('container-editor').style.height
    );
  };
}

export default MultiplosExamesContainer;



// WEBPACK FOOTER //
// ./src/app/common/multiplosExames/multiplosExames.container.js